// react hook that returns polygons data:

import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { updatePolygonLabel, deleteAll } from "../store/slices/polygonSlice"

export const useGetPolygons = () => {
  const dispatch = useDispatch()
  const updateLabel = useCallback(
    input => dispatch(updatePolygonLabel(input)),
    [dispatch]
  )
  const deletePolygons = useCallback(() => dispatch(deleteAll()), [dispatch])
  const polygons = useSelector(state =>
    state.polygon.present.polygons.map(polygon => ({
      id: polygon.id,
      label: polygon.label,
      points: polygon.points
    }))
  )
  const polygonsPoints = useSelector(state =>
    state.polygon.present.polygons.map(polygon => ({
      id: polygon.id,
      points: polygon.points,
      vertexRadius: 1,
      lineColor: polygon.lineColor,
      fillColor: polygon.fillColor, //"#37f71139",
      vertexColor: polygon.vertexColor,
      vertexStrokeWidth: 2
    }))
  )
  const activePolygonIndex = useSelector(
    state => state.polygon.present.activePolygonIndex
  )

  return {
    polygons,
    activePolygonIndex,
    polygonsPoints,
    updateLabel,
    deletePolygons
  }
}
